import * as React from 'react';
import { ThemeProvider } from 'styled-components';

import { FeatureProvider } from '@origin-digital/features';

import { Loader } from './components/Loader';
import { theme } from './styles';
import { AppRouter } from './Router';
import { getEnvironment } from './config/ConfigService';
import { TogglesFailedView } from './components/toggles-failed-view/TogglesFailedView';

const App: React.StatelessComponent<{}> = () => {
  return (
    <FeatureProvider
      loadingPlaceholder={<Loader />}
      failureView={<TogglesFailedView />}
      config={{ environment: getEnvironment() }}
    >
      <ThemeProvider theme={theme}>
        <AppRouter />
      </ThemeProvider>
    </FeatureProvider>
  );
};

export { App };
